import React, { useContext, useEffect } from 'react';
import { DropDown, Input, DateControl, InputFile, RadioButton } from '../components'
import { DataContext } from '../data/DataContext';
import { catSiNo, catCivilStatus, catGender } from '../data/MochaData'
import { ValidData } from '../data/Help'
import moment from 'moment';

const Step1 = () => {
    const { AutoEmisionCR, setAutoEmisionCR, ChangeHandler } = useContext(DataContext);
    const onChange = (property: string, value: string) => setAutoEmisionCR({ ...AutoEmisionCR, [property]: value });
    const changeFiles = (propierties: string, files: Array<File>, isMod: boolean) => setAutoEmisionCR({ ...AutoEmisionCR, [propierties]: files, [`${propierties}IsModified`]: isMod });

    const FinishDate = () => {
        let date = new Date();
        //date.setDate(date.getDate() + AutoEmisionCR.maxDayPlan);
        date.setDate(date.getDate() + 15);
        return date;
    }

    const onChangeDate = (propierties: string, value: Date) => {
        if (propierties === 'autoInsuranceStartDate') {
            let end = moment(value).add(1, 'year').add(-1, 'day').format('YYYY-MM-DD HH:mm:ss');
            setAutoEmisionCR({ ...AutoEmisionCR, [propierties]: value, autoInsuranceExpirationDate: new Date(end) })
        }
        else
            setAutoEmisionCR({ ...AutoEmisionCR, [propierties]: value })
    }

    return (
        <>
            <DropDown
                field='nationality'
                label='Nacionalidad'
                valueSelect={AutoEmisionCR.nationality}
                onChangeSelect={onChange}
                dataProvider={AutoEmisionCR.catNationality}
            />
            <DropDown
                field='sex'
                label='Sexo'
                valueSelect={AutoEmisionCR.sex}
                onChangeSelect={onChange}
                dataProvider={catGender}
            />
            <DateControl
                id='birthdate'
                label='Fecha de nacimiento'
                placeholder=''
                value={AutoEmisionCR.birthdate}
                onChange={onChangeDate}
                maxDate={new Date()}
            />
            <DropDown
                field='profession'
                label='Profesión'
                valueSelect={AutoEmisionCR.profession}
                onChangeSelect={onChange}
                dataProvider={AutoEmisionCR.catProfesion}
            />
            <Input
                id='company'
                label='Empresa donde labora'
                field='company'
                value={AutoEmisionCR.company}
                onChange={ChangeHandler}

            />
            <Input
                id='monthlyIncome'
                label='Ingresos mensuales $'
                field='monthlyIncome'
                value={AutoEmisionCR.monthlyIncome}
                onChange={onChange}
                type='CURRENCY_FORMAT'
                prefix='$ '

            />

            <InputFile
                id='identificationFrontImage'
                label='Documento de identificación frontal'
                files={AutoEmisionCR.identificationFrontImage}
                onChange={changeFiles}
                maxFiles={1}
            />
            <InputFile
                id='identificationBackImage'
                label='Documento de identificación trasera'
                files={AutoEmisionCR.identificationBackImage}
                onChange={changeFiles}
                maxFiles={1}
            />

            <DateControl
                id='autoInsuranceStartDate'
                label='Fecha de inicio del seguro'
                placeholder=''
                value={AutoEmisionCR.autoInsuranceStartDate}
                onChange={onChangeDate}
                minDate={new Date()}
                maxDate={FinishDate()}

            />
            <DateControl
                id='autoInsuranceExpirationDate'
                label='Fecha de vencimiento del seguro'
                placeholder=''
                value={AutoEmisionCR.autoInsuranceExpirationDate}
                onChange={onChangeDate}
                isReadOnly={true}
            />
            <DropDown
                field='civilStatus'
                label='Estado civil'
                valueSelect={AutoEmisionCR.civilStatus}
                onChangeSelect={onChange}
                dataProvider={catCivilStatus}
            />
            <RadioButton
                label='Tiene hijos'
                field={'haveChildren'}
                key={'haveChildren'}
                value={AutoEmisionCR.haveChildren}
                onChangeStr={onChange}
                onChange={() => { }}
                catalog={catSiNo}
                isRequired={false}
            />
            <RadioButton
                label='Posee casa propia'
                field={'ownHouse'}
                key={'ownHouse'}
                value={AutoEmisionCR.ownHouse}
                onChangeStr={onChange}
                onChange={() => { }}
                catalog={catSiNo}
                isRequired={false}
            />
            <Input
                id='address'
                label='Dirección'
                field='address'
                value={AutoEmisionCR.address}
                onChange={ChangeHandler}
                type='textarea'
            />
            <Input
                id='homePhone'
                label='Teléfono  de casa'
                field='homePhone'
                value={AutoEmisionCR.homePhone}
                onChange={ChangeHandler}
                placeholder='0000-0000'
                type='mask'
                mask="9999-9999"
                title="Documento invalido"
            />
            <DropDown
                field='countryOfOrigin'
                label='País de origen'
                valueSelect={AutoEmisionCR.countryOfOrigin}
                onChangeSelect={onChange}
                dataProvider={AutoEmisionCR.catCountryOfOrigin}
            />
            <DropDown
                field='province'
                label='Provincia'
                valueSelect={AutoEmisionCR.province}
                onChangeSelect={onChange}
                dataProvider={AutoEmisionCR.catProvince}
                key={'province'}
            />

            <DropDown
                field='canton'
                label='Cantón'
                valueSelect={AutoEmisionCR.canton}
                onChangeSelect={onChange}
                dataProvider={AutoEmisionCR.catCanton}
            />
            <DropDown
                field='district'
                label='Distrito'
                valueSelect={AutoEmisionCR.district}
                onChangeSelect={onChange}
                dataProvider={AutoEmisionCR.catDisctrict}
                key={'district'}
            />
            {/* <RadioButton
                label='Posee vehículo propio'
                field={'ownVehicle'}
                key={'ownVehicle'}
                value={AutoEmisionCR.ownVehicle}
                onChangeStr={onChange}
                onChange={() => { }}
                catalog={catSiNo}
                isRequired={false}
            /> */}
        </>
    )
}

export { Step1 }